module.exports = __webpack_public_path__ + "assets/img/title-myNB.1253140d.svg";